import GroupFAQ from '@/views/group-faq'
import ListGroupFAQ from '@/views/group-faq/list'
// import EditGroupFAQ from '@/views/group-faq/update'

export default {
  path: 'group-faq',
  component: GroupFAQ,
  redirect: 'group-faq/list',
  name: 'group-faq.group-faq',
  children: [
    {
      path: 'list',
      name: 'group-faq.list',
      component: ListGroupFAQ
    }
    // {
    //   path: 'edit/:group_faq_id',
    //   name: 'group-faq.group-faq',
    //   component: EditGroupFAQ
    // }
  ]
}



// WEBPACK FOOTER //
// ./src/router/group-faqs/group-faq.js